// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-bar-stacked';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.576.576v16.848M10.872 5.472H.576V2.088h10.296c.144 0 .288.072.432.144.144.144.144.288.144.432v2.232c0 .144-.072.288-.144.432-.144.072-.288.144-.432.144zm-3.024 5.616H.576V7.704h7.272c.144 0 .288.072.432.144.144.144.144.288.144.432v2.232c0 .144-.072.288-.144.432-.144.072-.288.144-.432.144zm6.768 5.616H.576V13.32h14.04c.144 0 .288.072.432.144.144.144.144.288.144.432v2.232c0 .144-.072.288-.144.432-.144.072-.288.144-.432.144zM8.064 2.088v3.384M5.976 7.704v3.384m4.032 2.232v3.384M6.912 13.32v3.384m-3.456-9v3.384m1.008-9v3.384'
  />
);

export const viewBox = '0 0 18 18';
